import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=abb7d238&scoped=true&"
import script from "./bind.vue?vue&type=script&lang=js&"
export * from "./bind.vue?vue&type=script&lang=js&"
import style0 from "./bind.vue?vue&type=style&index=0&id=abb7d238&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb7d238",
  null
  
)

export default component.exports